export default __webpack_public_path__ + "static/media/menuBurger.b2c2d4fa.svg";